import { DatePipe, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CustomOrderHistory } from '@order/const';
import { CustomMediaComponent } from '@sdvor/shared/ui';
import { SdModalService } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { QRCodeComponent } from 'angularx-qrcode';
import { OrderStatusLabelComponent } from '../order-status-label';
import { QrCodeModalComponent } from './qr-code-modal';

@Component({
  selector: 'sd-order-list-item',
  imports: [OrderStatusLabelComponent, DatePipe, SlicePipe, CustomMediaComponent, QRCodeComponent],
  templateUrl: './order-list-item.component.html',
  styleUrl: './order-list-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderListItemComponent {
  order = input.required<CustomOrderHistory>();

  isDesktopXlUp = toSignal(this.deviceService.isDesktopXlUp$);
  isMobileSmDown = toSignal(this.deviceService.isMobileSmDown$);
  shownEntriesCount = computed(() => (this.isDesktopXlUp() ? 6 : 4));

  constructor(
    private deviceService: DeviceService,
    private sdModalService: SdModalService,
  ) {}

  openQrModal(event: Event, orderCode: string): void {
    event.stopPropagation();
    event.stopImmediatePropagation();

    const modal = this.sdModalService.open(QrCodeModalComponent, { maxWidth: '400px' });

    modal.contentRef.setInput('orderCode', orderCode);
  }
}
